module.exports = __webpack_public_path__ + "static/img/advertisement04.4cec9479.jpg";